import PageLoader from 'components/PageLoader'
import React, { Suspense } from 'react'
import './i18n'

const I18nWrapper: React.FC = ({ children }) => {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>
}

export default I18nWrapper
